import { useQuery } from '@tanstack/react-query';
import { adminApi } from '@/api/users';
import { Users, Hash, MessageSquare, Activity, UserPlus } from 'lucide-react';

function StatCard({ icon: Icon, label, value, color }: {
  icon: React.ComponentType<{ size?: number; className?: string }>;
  label: string;
  value: number | string;
  color: string;
}) {
  return (
    <div className="bg-surface-900 border border-surface-800 rounded-xl p-5">
      <div className="flex items-center gap-3 mb-3">
        <div className={`p-2 rounded-lg ${color}`}>
          <Icon size={18} className="text-white" />
        </div>
        <span className="text-surface-400 text-sm">{label}</span>
      </div>
      <p className="text-3xl font-bold text-surface-50">{value.toLocaleString()}</p>
    </div>
  );
}

export default function AdminStats() {
  const { data, isLoading } = useQuery({
    queryKey: ['admin-stats'],
    queryFn: adminApi.getStats,
    refetchInterval: 30_000,
  });

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-surface-50 mb-6">Server Overview</h1>

      {isLoading ? (
        <div className="text-surface-500">Loading stats…</div>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">
          <StatCard icon={Users} label="Total Users" value={data?.totalUsers ?? 0} color="bg-blue-700" />
          <StatCard icon={Activity} label="Online Now" value={data?.activeUsers ?? 0} color="bg-green-700" />
          <StatCard icon={Hash} label="Channels" value={data?.totalChannels ?? 0} color="bg-purple-700" />
          <StatCard icon={MessageSquare} label="Total Messages" value={data?.totalMessages ?? 0} color="bg-orange-700" />
          <StatCard icon={UserPlus} label="New Users (7d)" value={data?.recentRegistrations ?? 0} color="bg-pink-700" />
        </div>
      )}
    </div>
  );
}
